import { colors } from "@/theme/colors";
import { IllustrationSvg } from "./IllustrationSvg";

/** The four module cards: position + tint, alternating the two surface tints. */
const MODULES = [
  { x: 30, y: 22, bg: colors.tintDeep },
  { x: 144, y: 22, bg: colors.paper },
  { x: 30, y: 80, bg: colors.paper },
  { x: 144, y: 80, bg: colors.tintDeep },
] as const;

/** The four connection dots on the hub ring, where the wires meet it. */
const HUB_DOTS = [
  [95, 49],
  [125, 49],
  [95, 79],
  [125, 79],
] as const;

/**
 * Flat illustration for the Custom offering: four modules wired into a central
 * hub — integrations and automations stitched together into one system.
 */
export function CustomIllustration() {
  return (
    <IllustrationSvg>
      {/* Wires from the hub out to each module (drawn first, behind them) */}
      <path
        d="M110 64 L53 36 M110 64 L167 36 M110 64 L53 94 M110 64 L167 94"
        stroke={colors.divider}
        strokeWidth="3"
        fill="none"
      />

      {/* Four connected modules */}
      {MODULES.map(({ x, y, bg }) => (
        <g key={`${x}-${y}`}>
          <rect
            x={x}
            y={y}
            width="46"
            height="28"
            rx="8"
            fill={bg}
            stroke={colors.divider}
            strokeWidth="2"
          />
          <rect
            x={x + 8}
            y={y + 9}
            width="24"
            height="4"
            rx="2"
            fill={colors.primary}
            opacity="0.5"
          />
          <rect
            x={x + 8}
            y={y + 17}
            width="16"
            height="4"
            rx="2"
            fill={colors.primary}
            opacity="0.3"
          />
        </g>
      ))}

      {/* Central hub */}
      <circle
        cx="110"
        cy="64"
        r="21"
        fill={colors.paper}
        stroke={colors.primary}
        strokeWidth="2"
      />
      <circle cx="110" cy="64" r="8" fill={colors.primary} />
      {HUB_DOTS.map(([cx, cy]) => (
        <circle
          key={`${cx}-${cy}`}
          cx={cx}
          cy={cy}
          r="3"
          fill={colors.primary}
        />
      ))}
    </IllustrationSvg>
  );
}
